import React, { FC, useEffect } from 'react';
import { Alert } from '@clearcover/atlas';
import { reportEvent } from 'Shared/analytics';
import { useAppContext, usePurchaseContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';

export const FCRA_ALERT =
  'A FCRA notice of the adverse action resulting from the required reports will be sent to the customer. No action is required from you.';

export const PurchaseAlertBanners: FC = () => {
  const { paymentDetails } = usePurchaseContext();
  const { displayFCRANotice } = useAppContext();

  useEffect(() => {
    if (displayFCRANotice) {
      reportEvent('aqui-purchase-fcra-notice-displayed');
    }
  }, [displayFCRANotice]);

  return paymentDetails ? (
    <div className={styles.container} data-testid="purchase-alert-banners">
      {paymentDetails.messages.length > 0 && (
        <Alert
          data-testid="payment-details-alerts"
          type="info"
          message={
            <ul>
              {paymentDetails.messages.map((message) => (
                <li className={styles.message} key={message}>
                  {message}
                </li>
              ))}
            </ul>
          }
        />
      )}
      {displayFCRANotice && (
        <Alert data-testid="fcra-alert" type="info" message={FCRA_ALERT} />
      )}
    </div>
  ) : null;
};
